import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import e from 'cors';

interface ReassuranceItem {
  image: string;
  title: string;
  text: string;
  link: string;
  alt: string;
}

@Component({
  selector: 'app-reassurance',
  templateUrl: './reassurance.component.html',
  styleUrls: ['./reassurance.component.scss'],
})
export class ReassuranceComponent implements AfterViewInit, OnDestroy {
  @ViewChild('cardsContainer', { static: true }) cardsContainer!: ElementRef;
  isMobile = false;
  private boundApplyOverlayMask!: (e: PointerEvent) => void;

  reassuranceItems: ReassuranceItem[] = this.translate.instant(
    'home_reassurance.contents'
  );

  constructor(private translate: TranslateService) {}

  ngAfterViewInit(): void {
    this.isMobile = window.innerWidth < 1200;
    this.boundApplyOverlayMask = this.applyOverlayMask.bind(this);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isMobile) {
            document.body.addEventListener(
              'pointermove',
              this.boundApplyOverlayMask
            );
          } else {
            document.body.removeEventListener(
              'pointermove',
              this.boundApplyOverlayMask
            );
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(this.cardsContainer.nativeElement);
  }

  applyOverlayMask(e: PointerEvent) {
    if (!this.cardsContainer) return;
    const cardsContainer = this.cardsContainer.nativeElement as HTMLElement;
    const overlay = this.cardsContainer.nativeElement.querySelector(
      '.overlay'
    ) as HTMLElement;

    if (!cardsContainer || !overlay) return;

    const x = e.pageX - cardsContainer.offsetLeft;
    const y = e.pageY - cardsContainer.offsetTop;
    overlay.style.setProperty('--opacity', '1');
    overlay.style.setProperty('--x', `${x}px`);
    overlay.style.setProperty('--y', `${y}px`);
  }

  ngOnDestroy(): void {
    document.body.removeEventListener(
      'pointermove',
      this.boundApplyOverlayMask
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.isMobile = window.innerWidth < 1200;
  }
}
